import type { TradeSummary } from '../api/types'
import { tradeKey } from './liveFeedGate'

/** Insertion-ordered buffer for the finite REST hydration barrier.
 * Duplicate deliveries collapse by structural trade identity. */
export class HydrationTradeBuffer {
  private readonly trades = new Map<string, TradeSummary>()
  private anonymousSequence = 0

  push(trade: TradeSummary): void {
    const key = tradeKey(trade) || `anonymous:${++this.anonymousSequence}`
    if (this.trades.has(key)) return
    this.trades.set(key, trade)
  }

  values(): TradeSummary[] {
    return [...this.trades.values()]
  }

  delete(trade: TradeSummary): void {
    const key = tradeKey(trade)
    if (key) this.trades.delete(key)
  }

  drain(): TradeSummary[] {
    const pending = [...this.trades.values()]
    this.clear()
    return pending
  }

  clear(): void {
    this.trades.clear()
    this.anonymousSequence = 0
  }

  get size(): number {
    return this.trades.size
  }
}
